import { render, staticRenderFns } from "./WeeklyGIDetailForThailand.vue?vue&type=template&id=5456d131&scoped=true"
import script from "./WeeklyGIDetailForThailand.vue?vue&type=script&lang=js"
export * from "./WeeklyGIDetailForThailand.vue?vue&type=script&lang=js"
import style0 from "./WeeklyGIDetailForThailand.vue?vue&type=style&index=0&id=5456d131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5456d131",
  null
  
)

export default component.exports